import { __assign } from "tslib";
import axios from "axios";
import { initEnv, biliBridge, isSupport, inBiliApp } from "@bilibili/js-bridge";
import logger from "./logger";
var uploadImage = "//www.bilibili.com/activity/upimage";
export var u = navigator.userAgent.toLocaleLowerCase();
export var isAndroid = /android|adr|linux/gi.test(u);
export var isiOS = /ipad|iphone|ipod/.test(u);
export var isIpad = /ipad/.test(u);
export var isSafari = /safari/.test(u);
export var isWechat = /micromessenger/i.test(u);
export var isQQ = /qq\//.test(u);
export var isWeibo = /_weibo_/.test(u);
export var biliapp = inBiliApp;
export var isIphonex = function () {
    if (typeof window !== "undefined" && window) {
        return biliapp && /iphone/gi.test(u) && window.screen.height >= 812;
    }
    return false;
};
initEnv();
export function toast(msg, duration) {
    var d = duration || 3000;
    var msgStyle = {
        position: "fixed",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, 0)",
        boxSizing: "border-box",
        width: "auto",
        padding: "0.12rem 0.24rem",
        borderRadius: "8px",
        maxWidth: "80%",
        background: "rgba(0, 0, 0, .7)",
        fontSize: "0.28rem",
        color: "#fff",
        lineHeight: 1.5,
        userSelect: "none",
        wordWrap: "break-word",
        opacity: 0,
        zIndex: 99999,
        cursor: "default",
        transition: "all .3s ease-in-out",
        textAligin: "justify"
    };
    var node = document.createElement("div");
    Object.keys(msgStyle).forEach(function (key) {
        node.style[key] = msgStyle[key];
    });
    node.innerText = msg;
    document.body.appendChild(node);
    setTimeout(function () {
        node.style.transform = "translate(-50%, -50%)";
        node.style.opacity = "1";
    }, 10);
    setTimeout(function () {
        document.body.removeChild(node);
    }, d);
}
export function getAppInfo() {
    return new Promise(function (resolve) {
        if (!inBiliApp) {
            return resolve({});
        }
        biliBridge.callNative({
            method: "global.getContainerInfo",
            callback: function (info) {
                resolve(info);
            }
        });
    });
}
export function detectShareRoute() {
    if (isQQ) {
        return "qq";
    }
    else if (isWechat) {
        return "weixin";
    }
    else if (isWeibo) {
        return "sina";
    }
    return "other";
}
export function getUserinfo() {
    return new Promise(function (resolve) {
        if (!inBiliApp) {
            var mid = getCookie("DedeUserID") || 0;
            return resolve({ mid: mid });
        }
        biliBridge.callNative({
            method: "auth.getUserInfo",
            data: {
                type: "default"
            },
            callback: function (userInfo) {
                resolve(userInfo);
            }
        });
    });
}
export function report(key, param) {
    if (param === void 0) { param = {}; }
    var p = __assign({ route: detectShareRoute() }, param);
    logger(key, p);
}
export function openAppLink(schema) {
    biliBridge.callNative({
        method: "ability.openScheme",
        data: {
            url: schema
        }
    });
}
export function openLink(url) {
    if (inBiliApp) {
        biliBridge.callNative({
            method: "ability.openScheme",
            data: {
                url: "bilibili://browser/?url=" + encodeURIComponent(url)
            }
        });
    }
    else {
        location.href = url;
    }
}
export function getLoginByCallback(url) {
    url = url || location.href;
    if (inBiliApp) {
        isSupport("auth.login").then(function (support) {
            if (support) {
                biliBridge.callNative({
                    method: "auth.login",
                    data: {
                        type: "default",
                        business: "fission"
                    },
                    onLogin: function (data) {
                        console.log("onLoginCallback", data);
                        if (isAndroid) {
                            var state = data.state;
                            if (+state) {
                                openLink(url);
                            }
                            else {
                                toast("登录失败~点击重试");
                            }
                        }
                    },
                    complete: function (data) {
                        console.warn("auth.login complete");
                        if (isiOS) {
                            var state = data.state;
                            if (+state) {
                                openLink(url);
                            }
                            else {
                                toast("登录失败~点击重试");
                            }
                        }
                    },
                    callback: function () {
                        console.log("调起登陆窗口");
                    }
                });
            }
            else {
                var uri = "" + url + (url.indexOf("?") > -1 ? "&" : "?") + "toLogin=true";
                window.biliapp.openScheme(JSON.stringify({
                    url: "bilibili://loginWithGoBackUrl?gobackurl=" + encodeURIComponent(uri)
                }));
            }
        });
    }
    else {
        location.href = "http://passport.bilibili.com/login?gourl=" + url;
    }
}
export function getLogin(url) {
    var u = url || location.href;
    if (inBiliApp) {
        isSupport("auth.login").then(function (support) {
            if (support) {
                biliBridge.callNative({
                    method: "auth.login",
                    data: {
                        type: "default",
                        callbackUrl: u
                    }
                });
            }
            else {
                var uri = "" + u + (u.indexOf("?") > -1 ? "&" : "?") + "toLogin=true";
                window.biliapp.openScheme(JSON.stringify({
                    url: "bilibili://loginWithGoBackUrl?gobackurl=" + encodeURIComponent(uri)
                }));
            }
        });
    }
    else {
        location.href = "https://passport.bilibili.com/login?gourl=" + encodeURIComponent(u);
    }
}
export function upload(blob) {
    var headers = {
        "Content-Type": "multipart/form-data"
    };
    var fd = new FormData();
    fd.append("img", blob);
    fd.append("message", "image");
    return axios.post(uploadImage, fd, { headers: headers });
}
export function getCookie(key) {
    var arr;
    var reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
    if ((arr = document.cookie.match(reg))) {
        return unescape(arr[2]);
    }
    else {
        return "";
    }
}
export function setCookie(name, value, days) {
    if (days === void 0) { days = 1; }
    var exp = new Date();
    exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
        name + "=" + encodeURIComponent(value) + ";expires=" + exp.toUTCString() + "; path=/; domain=.bilibili.com";
}
